import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { MyDatePickerModule } from 'mydatepicker';

import { SharedAppModule } from '../app.shared.module';
// import { TruncatePipe } from '../pipe/exponential-strength.pipe';

import { UsersComponent } from './users.component';
import { UsersRoutingModule } from './users-routing.module';


// import { LandingComponent } from './landing/landing.component';
// import { LoginComponent } from './login/login.component';
// import { SignupComponent } from './signup/signup.component';
// import { HomeComponent } from './home/home.component';
import { InterestComponent } from './interest/interest.component';
// import { TermsComponent } from './terms/terms.component';
// import { PrivacyComponent } from './privacy/privacy.component';
// import { UserResetrpasswordComponent } from './resetpassword/resetpassword.component';
// import { WallComponent } from './wall/wall.component';
// import { UserHeaderBeforeLoginComponent } from '../common/user-header-before-login.component';
//import { UserHeaderBeforeSignupComponent } from '../common/user-header-before-signup.component';
// import { HeaderComponent } from '../admin/shared/components/header/header.component';
// import { FooterComponent } from '../common/footer.component';
// import { HeaderMenuAccountComponent } from '../common/headermenuAccount.component';
//import { HeaderMenuComponent } from '../common/headermenu.component';

//popup components
import { PopupInterestComponent } from './popup/popup.interest.component';
import { PopupContactComponent } from '../common/popup-contact.component';

@NgModule({
  imports: [
    CommonModule,
    UsersRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedAppModule,
    CarouselModule,
    InfiniteScrollModule,
    MyDatePickerModule,
    
  ],
  entryComponents: [
    // PopupSignupComponent, 
    PopupInterestComponent, 
    // PopupIphoneComponent,
    // PopupLogoutComponent,
    // PopupLogComponent,
    // PopupSegmentComponent,
    // CoupanCheckComponent,
    // ImageCroperComponent
    // ,DeleteConfirmComponent,
    // ZizDeleteConfirmComponent, 
    // PopupDetailComponent,
    // profileimageCroperComponent,
    // AdminImageCroperComponent,
    PopupContactComponent,
     
],
  declarations: [
    UsersComponent,
    // LandingComponent,
    // LoginComponent,
    // SignupComponent,
    // HomeComponent,
    // InterestComponent,
    // TermsComponent,
    // PrivacyComponent,
    // UserResetrpasswordComponent,
    // WallComponent,

    PopupInterestComponent,
    PopupContactComponent,
    
    // UserHeaderBeforeLoginComponent,
    //UserHeaderBeforeSignupComponent,
    // HeaderMenuAccountComponent,
    //HeaderMenuComponent,
    // FooterComponent,


    // TruncatePipe
  ],
  exports: [
    // FooterComponent
  ]
})
export class UsersModule { }



// WEBPACK FOOTER //
// ./src/app/users/users.module.ts